import apiClient from '@/plugins/axios'

export default {
  getTipoAcionados() {
    return apiClient.get('tipoacionado')
  },

  getTipoAcionado(id) {
    return apiClient.get(`tipoacionado/${id}`)
  },

  postTipoAcionado(tipo_acionado) {
    return apiClient.post(`tipoacionado`, { tipo_acionado })

  },

  putTipoAcionado(id, tipo_acionado) {
    return apiClient.put(`tipoacionado/${id}`, { tipo_acionado })

  },

  deleteTipoAcionado(id) {
    return apiClient.delete(`tipoacionado/${id}`)

  },

  getDropDown() {
    return apiClient.get(`tipoacionado/dropdown`)

  }

}


// WEBPACK FOOTER //
// ./src/views/TipoAcionado/_services/TipoAcionadoService.js